<template>
    <div>
      <Header></Header>
      <Alert v-if="message.length > 0" @on-close="test" type="error" closable style="margin:0 auto;width: 70%;">{{message}}</Alert>
      <div>
        <Titleline :title="title"></Titleline>
      </div>
      <Form :model="formItem" :label-width="80">
        <!-- <FormItem label="ID">
            <Input v-model="formItem.id" placeholder="自动生成" disabled/>
        </FormItem> -->
        <FormItem label="关键字" style="text-align:left">
            <Input id="ppgjc" style="width: 200px" v-model="formItem.keywords" type="text" placeholder="品牌词"/>
            <Button id="jiexici" style="margin-left: 8px" @click="test">解析品牌</Button>
            <p><span style="color:blue"></span><span style="color:blue">每次输入一个词进行解析，然后选择解析后品牌再点添加品牌按钮</span></p>
            <div style="min-height:45px; border-radius: 4px; border: 1px solid #e2e2e2;margin-top: 0px;margin-right: 10px;padding: 8px 10px;">
              <CheckboxGroup v-model="brandSelectedList">
                <!-- <Checkbox label="香蕉" border></Checkbox> -->
                <Checkbox v-for="(val, key) in brandPList" :label="val.name" :key="key" border></Checkbox>
              </CheckboxGroup>
            </div>
            <div style="margin-top: 10px;">
              <Button @click="tjbrnad">添加品牌</Button>
            </div>
            <p>已添加代采集品牌</p>
            <div style="min-height:45px; border-radius: 4px; border: 1px solid #e2e2e2;margin-top: 0px;margin-right: 10px;padding: 8px 10px;">
              <Tag v-for="(val, key) in brandlist" type="border" :name="val.name" :key="key" closable @on-close="ondeltag">{{ val.name }}</Tag>
            </div>
        </FormItem>
        <FormItem label="指数类型" style="text-align: left;">
          <RadioGroup v-model="formItem.searchtype">
              <Radio label="0">综合</Radio>
              <Radio label="1">搜索</Radio>
              <Radio label="2">资讯</Radio>
              <Radio label="3">互动</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="结果类型" style="text-align: left;" v-show="formItem.searchtype == '1' || formItem.searchtype == '3'">
          <RadioGroup v-model="formItem.resultcol" >
              <Radio label="0">PC+移动</Radio>
              <Radio label="1">PC</Radio>
              <Radio label="2">移动</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="开始日期">
            <Row style="text-align: left;">
                <Col>
                  <DatePicker type="date" placeholder="选择时间" v-model="formItem.begin_at"></DatePicker>
                  时间最早为2022-01-01
                </Col>
            </Row>
        </FormItem>
        <FormItem label="结束日期">
            <Row style="text-align: left;">
                <Col span="11">
                  <DatePicker type="date" placeholder="选择时间" v-model="formItem.end_at"></DatePicker>
                  时间最晚为昨天
                </Col>
            </Row>
        </FormItem>
        <FormItem label="选择地区" style="text-align: left;">
            <Checkbox v-model="formItem.all">全国总数</Checkbox>
            <span style="color:blue;">{{regiontip}}</span>
            <CheckboxGroup v-model="formItem.selRegion">
              <p>省份：
                <i-switch size="large" @on-change="handleShengCheckAll">
                <span slot="open">关闭</span>
                <span slot="close">全选</span></i-switch></p>
              <Checkbox v-for="(val, key) in regions" :label="key" :key="key">{{val}}</Checkbox>
              <p>城市：<i-switch v-model="city_show" size="large">
                <span slot="open">显示</span>
                <span slot="close">隐藏</span>
            </i-switch></p>
              <List border v-show="city_show">
                <ListItem v-for="(cityarray, pro) in pro_city"  :key="pro"><i-switch @on-change="handleShiCheckAll(pro)">
                <span slot="open">关</span>
                <span slot="close">全</span></i-switch>&nbsp;{{ pro }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Checkbox v-for="(val, key) in cityarray" :label="key" :key="key">{{val}}</Checkbox>
                </ListItem>
              </List>
            </CheckboxGroup>
        </FormItem>
        <input type="hidden" id="params" name="" v-model="allparams">
        <input type="hidden" id="msg" name="" v-model="nmsg">
        <input type="hidden" id="taskinfo" name="" v-model="taskinfo">
        <input type="hidden" id="downlist" name="" v-model="downlistjson">
        <input type="hidden" id="kzversionid" name="" v-model="kzversion">
        <input type="hidden" id="iniscontinue" name="" v-model="iniscontinueV">
        <input type="hidden" id="vipinfo" name="" v-model="vipinfo">
        <input type="hidden" id="tasklittle" name="" v-model="tasklittle">
        <input type="hidden" id="brandparse" name="" v-model="brandparse">
        <input type="hidden" id="brandlistJson" name="" v-model="brandlistJson">

        <FormItem style="text-align:left;">
            <Button id="begin" type="primary" @click="test">开始采集</Button>
            <Button style="margin-left: 8px" @click="cancel">取消</Button>
            <Button style="margin-left: 8px" id="contok" @click="contok" :disabled="is_disable">继续采集</Button>
            <!-- <Button style="margin-left: 8px" id="openfolder">打开下载目录</Button> -->
            <span style="margin-left: 100px;font-size:20px" v-show="nokz">请先安装浏览器扩展<a class="sec" href="/introne#kz">（点击这里下载）</a>，所有操作都在一个浏览器执行</span>
        </FormItem>
        <p class="wxts-p">温馨提示：在开始采集数据之前，请先在浏览器的其他页面提前登录一下百度指数账号，采集过程中使用会该账号进行采集</p>
      </Form>
      <div v-show="mallcount > 0">
        <Titleline title="采集结果"></Titleline>
          <div  style="text-align:left;margin:20px 50px;width:80%">
            <p>说明：在采集的过程中，<span style="color:red">不要刷新页面</span>，否则已经采集到的数据都会被<span style="color:red">清空</span>了，白忙活了。切记！</p>
            <p>风险提示：采集过程任务多的情况下，会有帐号被<span style="color:red">百度指数官方限制查询</span>的问题，可以考虑多准备几个百度指数账号，更换使用！限制查询一般6～7天后会自动解除</p>
            <br>
            <Alert v-if="message.length > 0" @on-close="test" type="error" closable>{{message}}</Alert>
            <p>采集进度<img v-if="running && is_disable" style="height: 21px;opacity: 0.7;vertical-align: bottom;" src="../../static/images/exec.gif"></img></p>
            <Progress :percent="process" :stroke-width="20" status="active" text-inside />
          </div>
          <div style="text-align:left;margin:20px 50px;width:80%">
            <!-- <p>由于采集内容太多，只显示需要采集的次数数据</p> -->
            <p>总采集数：{{mallcount}}</p>
            <p>已采集数：{{mallfinished}}</p>
          </div>
          <div style="margin: 80px 0">
          </div>
      </div>
    </div>
</template>
<script>
import Titleline from './titleline'
import Header from './header'
import helper from '../lib/helper'

export default {
  components: {
    Titleline,
    Header
  },
  watch: {
    'iniscontinueV': function (val, oldVal) {
      console.log('继续按钮')
      if (val.length === 0) {
        this.is_disable = true
      } else {
        this.is_disable = false
      }
    },
    '$store.state.vipinfo': function (val, oldVal) {
      this.gentip(this.$store.state.vipinfo)
    },
    'brandparse': function (val, oldVal) {
      this.brandPList = JSON.parse(val)
    },
    'brandlist': function (val, oldVal) {
      this.brandlistJson = JSON.stringify(val)
      this.allparams = this.formJson()
    },
    // 用于传参给扩展。
    'formItem.keywords': function (val, oldVal) {
      // console.log('keywords is change')
      this.checkkw()
      this.allparams = this.formJson()
    },
    'formItem.begin_at': function (val, oldVal) {
      this.allparams = this.formJson()
    },
    'formItem.end_at': function (val, oldVal) {
      this.allparams = this.formJson()
    },
    'formItem.selRegion': function (val, oldVal) {
      this.checkregion()
      this.allparams = this.formJson()
    },
    'formItem.searchtype': function (val, oldVal) {
      this.allparams = this.formJson()
      console.log(this.allparams)
    },
    'formItem.resultcol': function (val, oldVal) {
      this.allparams = this.formJson()
      console.log(this.allparams)
    },
    'formItem.all': function (val, oldVal) {
      this.checkregion()
      this.allparams = this.formJson()
    },
    'downlist': function (val, oldVal) {
      this.downlistjson = JSON.stringify(this.downlist)
    },
    'nmsg': function (val, oldVal) {
      if (val.length === 0) {
        return
      }
      // this.$Message.error({
      //   content: val,
      //   duration: 10
      // })
      this.message = val
      this.nmsg = ''
    },
    'tasklittle': function (val, oldVal) {
      this.taskts = new Date().getTime()
      if (val.length === 0) {
        return
      }
      var t = JSON.parse(val)
      // console.log('shijian1', t)
      this.running = true
      this.showlist = false
      this.mallcount = t.allcount
      this.mallfinished = t.allfinished
      if (this.mallcount === 0) {
        // 避免0位除数
        this.process = 100
      } else {
        this.process = Math.floor(this.mallfinished / this.mallcount * 100)
      }
      if (this.process >= 100) {
        this.running = false
      }
    },
    'taskinfo': function (val, oldVal) {
      this.cleardata()
      this.taskts = new Date().getTime()
      if (val.length === 0) {
        return
      }
      // var t = JSON.parse(val)
      // console.log('taskinfo values: ', t)
      this.running = true
      // 计算总进度度
      var allcount = 0
      var allfinished = 0
      var res = []
      this.downlist.length = 0
      this.tasklist = res
      this.mallcount = allcount
      this.mallfinished = allfinished
      if (allcount === 0) {
        // 避免0位除数
        this.process = 100
      } else {
        this.process = Math.floor(allfinished / allcount * 100)
      }
      if (this.process >= 100) {
        this.running = false
      }
    }
  },
  data () {
    return {
      title: '品牌指数',
      brandSelectedList: [],
      brandPList: [],
      brandparse: '',
      brandlist: [],
      brandlistJson: '',
      message: '',
      mallfinished: 0,
      mallcount: 0,
      showlist: true,
      tasklittle: '',
      formItem: {
        keywords: '',
        begin_at: '',
        end_at: '',
        all: true,
        searchtype: '0',
        resultcol: '0',
        selRegion: []
      },
      vipinfo: '',
      kwtip: '',
      kwnum: 5,
      regiontip: '',
      regionnum: 1,
      subCheck: {},
      nmsg: '',
      is_disable: true,
      iniscontinueV: '',
      taskts: 0,
      taskinfo: '',
      // 展示使用
      tasklist: [
      // {
      //   code: '0',
      //   count: 1,
      //   finished: 1,
      //   region: '全国',
      //   word: '手套'
      // }, {
      //   code: '0',
      //   count: 1,
      //   finished: 0,
      //   region: '全国',
      //   word: '帽子'
      // }
      ],
      process: 0,
      running: false, // 任务运行中点击开始按钮
      downlist: [],
      downlistjson: '',
      nokz: false,
      kzversion: '',
      allparams: '',
      city_show: false,
      regions: {
        1: '北京',
        2: '上海',
        3: '天津',
        4: '广东',
        5: '福建',
        8: '海南',
        9: '安徽',
        10: '贵州',
        11: '甘肃',
        12: '广西',
        13: '河北',
        14: '河南',
        15: '黑龙江',
        16: '湖北',
        17: '湖南',
        18: '吉林',
        19: '江苏',
        20: '江西',
        21: '辽宁',
        22: '内蒙古',
        23: '宁夏',
        24: '青海',
        25: '山东',
        26: '山西',
        27: '陕西',
        28: '四川',
        29: '西藏',
        30: '新疆',
        31: '云南',
        32: '浙江',
        33: '重庆',
        34: '香港',
        35: '台湾',
        36: '澳门'
      },
      pro_city: {
        '安徽': {
          142: '合肥',
          138: '铜陵',
          132: '黄山',
          130: '池州',
          136: '宣城',
          129: '巢湖',
          133: '淮南',
          137: '宿州',
          135: '六安',
          131: '滁州',
          127: '淮北',
          140: '阜阳',
          134: '马鞍山',
          128: '安庆',
          141: '蚌埠',
          139: '芜湖',
          143: '亳州'
        },
        '福建': {
          81: '福州',
          48: '莆田',
          66: '三明',
          50: '龙岩',
          70: '厦门',
          52: '泉州',
          80: '漳州',
          51: '宁德',
          49: '南平'
        },
        '广东': {
          84: '广州',
          93: '深圳',
          116: '东莞',
          111: '云浮',
          90: '佛山',
          110: '湛江',
          82: '江门',
          117: '惠州',
          113: '珠海',
          94: '韶关',
          109: '阳江',
          86: '茂名',
          85: '潮州',
          83: '揭阳',
          112: '中山',
          89: '清远',
          114: '肇庆',
          115: '河源',
          88: '梅州',
          91: '汕头',
          92: '汕尾'
        },
        '广西': {
          99: '南宁',
          101: '柳州',
          95: '桂林',
          107: '贺州',
          96: '贵港',
          105: '玉林',
          106: '河池',
          104: '北海',
          102: '钦州',
          98: '防城港',
          108: '百色',
          103: '梧州',
          100: '来宾',
          478: '崇左'
        },
        '甘肃': {
          258: '兰州',
          262: '庆阳',
          263: '定西',
          264: '武威',
          255: '酒泉',
          266: '张掖',
          257: '嘉峪关',
          260: '平凉',
          265: '天水',
          267: '白银',
          256: '金昌',
          259: '陇南',
          261: '临夏',
          477: '甘南'
        },
        '贵州': {
          118: '贵阳',
          121: '黔南',
          120: '六盘水',
          126: '遵义',
          122: '黔东南',
          125: '铜仁',
          119: '安顺',
          124: '毕节',
          123: '黔西南'
        },
        '河北': {
          327: '石家庄',
          332: '衡水',
          331: '张家口',
          306: '承德',
          325: '秦皇岛',
          307: '廊坊',
          305: '沧州',
          304: '保定',
          329: '唐山',
          330: '邯郸',
          326: '邢台'
        },
        '黑龙江': {
          335: '哈尔滨',
          342: '大庆',
          341: '伊春',
          343: '大兴安岭',
          345: '黑河',
          344: '鹤岗',
          338: '七台河',
          337: '齐齐哈尔',
          334: '佳木斯',
          336: '牡丹江',
          333: '鸡西',
          339: '绥化',
          340: '双鸭山'
        },
        '河南': {
          322: '郑州',
          315: '南阳',
          317: '新乡',
          310: '开封',
          308: '焦作',
          313: '平顶山',
          319: '许昌',
          309: '安阳',
          314: '驻马店',
          318: '信阳',
          323: '鹤壁',
          324: '周口',
          320: '商丘',
          311: '洛阳',
          312: '漯河',
          316: '濮阳',
          321: '三门峡',
          476: '济源'
        },
        '湖南': {
          352: '长沙',
          361: '岳阳',
          360: '衡阳',
          363: '株洲',
          356: '湘潭',
          359: '益阳',
          353: '郴州',
          357: '湘西',
          354: '娄底',
          350: '怀化',
          351: '常德',
          358: '张家界',
          362: '永州',
          355: '邵阳'
        },
        '湖北': {
          371: '武汉',
          348: '黄石',
          347: '荆州',
          370: '襄阳',
          349: '黄冈',
          346: '荆门',
          376: '宜昌',
          369: '十堰',
          367: '随州',
          366: '恩施',
          377: '鄂州',
          375: '咸宁',
          365: '孝感',
          372: '仙桃',
          373: '天门',
          364: '潜江',
          368: '神农架'
        },
        '海南': {
          302: '海口',
          301: '万宁',
          297: '琼海',
          298: '三亚',
          303: '儋州',
          296: '东方',
          300: '五指山',
          299: '文昌',
          486: '陵水',
          487: '澄迈',
          490: '乐东',
          491: '临高',
          484: '定安',
          492: '昌江',
          485: '屯昌',
          488: '保亭',
          493: '白沙',
          489: '琼中'
        },
        '吉林': {
          40: '长春',
          43: '四平',
          41: '辽源',
          44: '松原',
          38: '吉林',
          45: '通化',
          42: '白山',
          39: '白城',
          47: '延边'
        },
        '江苏': {
          55: '南京',
          59: '苏州',
          62: '无锡',
          57: '连云港',
          53: '淮安',
          64: '扬州',
          61: '泰州',
          63: '盐城',
          58: '徐州',
          54: '常州',
          56: '南通',
          65: '镇江',
          60: '宿迁'
        },
        '江西': {
          72: '南昌',
          67: '九江',
          76: '鹰潭',
          78: '抚州',
          74: '上饶',
          77: '赣州',
          68: '吉安',
          71: '萍乡',
          69: '景德镇',
          73: '新余',
          75: '宜春'
        },
        '辽宁': {
          153: '沈阳',
          155: '大连',
          149: '盘锦',
          151: '鞍山',
          147: '朝阳',
          146: '锦州',
          154: '铁岭',
          144: '丹东',
          145: '本溪',
          156: '营口',
          152: '抚顺',
          150: '阜新',
          148: '辽阳',
          157: '葫芦岛'
        },
        '内蒙古': {
          167: '呼和浩特',
          169: '包头',
          168: '鄂尔多斯',
          162: '巴彦淖尔',
          164: '乌海',
          159: '阿拉善盟',
          165: '锡林郭勒盟',
          158: '赤峰',
          161: '通辽',
          166: '呼伦贝尔',
          163: '乌兰察布',
          160: '兴安盟'
        },
        '宁夏': {
          174: '银川',
          172: '吴忠',
          170: '固原',
          171: '石嘴山',
          173: '中卫'
        },
        '青海': {
          175: '西宁',
          177: '海西',
          176: '海东',
          178: '玉树',
          479: '海南',
          494: '海北',
          495: '黄南',
          496: '果洛'
        },
        '四川': {
          226: '成都',
          254: '宜宾',
          229: '绵阳',
          225: '广元',
          237: '遂宁',
          247: '巴中',
          235: '内江',
          234: '泸州',
          231: '南充',
          232: '德阳',
          233: '乐山',
          224: '广安',
          238: '资阳',
          253: '自贡',
          230: '攀枝花',
          250: '达州',
          251: '雅安',
          227: '眉山',
          236: '甘孜',
          252: '阿坝',
          228: '凉山'
        },
        '山东': {
          196: '济南',
          223: '滨州',
          202: '青岛',
          219: '烟台',
          201: '临沂',
          204: '潍坊',
          207: '淄博',
          220: '东营',
          199: '聊城',
          222: '菏泽',
          221: '枣庄',
          200: '德州',
          218: '威海',
          197: '济宁',
          208: '泰安',
          198: '莱芜',
          203: '日照'
        },
        '山西': {
          214: '太原',
          217: '大同',
          209: '长治',
          212: '忻州',
          206: '晋中',
          211: '临汾',
          216: '运城',
          205: '晋城',
          213: '朔州',
          215: '阳泉',
          210: '吕梁'
        },
        '陕西': {
          244: '西安',
          242: '铜川',
          240: '安康',
          239: '宝鸡',
          241: '商洛',
          243: '渭南',
          248: '汉中',
          245: '咸阳',
          249: '榆林',
          246: '延安'
        },
        '西藏': {
          269: '拉萨',
          271: '日喀则',
          268: '那曲',
          270: '林芝',
          497: '山南',
          480: '昌都',
          498: '阿里'
        },
        '新疆': {
          192: '乌鲁木齐',
          187: '石河子',
          190: '吐鲁番',
          181: '昌吉',
          179: '哈密',
          185: '阿克苏',
          184: '克拉玛依',
          180: '博尔塔拉',
          182: '阿勒泰',
          183: '喀什',
          195: '和田',
          191: '巴音郭楞',
          193: '伊犁',
          188: '塔城',
          186: '克孜勒苏柯尔克孜',
          // 660: '伊犁哈萨克',
          189: '五家渠',
          499: '阿拉尔',
          500: '图木舒克'
        },
        '云南': {
          284: '昆明',
          295: '玉溪',
          283: '楚雄',
          292: '大理',
          294: '昭通',
          293: '红河',
          288: '曲靖',
          285: '丽江',
          287: '临沧',
          291: '文山',
          289: '保山',
          290: '普洱',
          483: '西双版纳',
          286: '德宏',
          481: '怒江',
          482: '迪庆'
        },
        '浙江': {
          280: '杭州',
          275: '丽水',
          272: '金华',
          278: '温州',
          279: '台州',
          274: '衢州',
          276: '宁波',
          277: '绍兴',
          273: '嘉兴',
          282: '湖州',
          281: '舟山'
        }
      }
    }
  },
  computed: {
  },
  mounted: function () {
    // console.log('params ', this.$route.query)
    // if (this.$route.query && this.$route.query.id) {
    //   this.loaddetail(this.$route.query.id)
    // }
    // var that = this
    // setTimeout(function () {
    //   if (that.kzversion.length === 0) {
    //     that.nokz = true
    //     console.log('no version ', that.kzversion)
    //   } else {
    //     that.nokz = false
    //     console.log('version ', that.kzversion)
    //   }
    // }, 10000)
    setInterval(() => {
      this.timehandle()
    }, 5000)
    this.getVipInfo()
    this.gentip(this.$store.state.vipinfo)
  },
  methods: {
    ondeltag (event, name) {
      this.test()
      console.log('ondeltag', event, name)
      for (let i in this.brandlist) {
        if (this.brandlist[i].name === name) {
          this.brandlist.splice(i, 1)
        }
      }
    },
    tjbrnad () {
      this.test()
      for (let i in this.brandPList) {
        if (this.brandSelectedList.includes(this.brandPList[i].name)) {
          if (!this.brandlist.includes(this.brandPList[i])) {
            this.brandlist.push(this.brandPList[i])
          }
        }
      }
      // console.log('tjbrnad', this.brandSelectedList, this.brandlist)
    },
    formJson () {
      let t = this.formItem.keywords.replace(/\r\n/g, ',')
      let r = t.replace(/\n/g, ',')
      let f = {
        keyword: r,
        begin_at: this.formItem.begin_at,
        end_at: this.formItem.end_at,
        all: this.formItem.all,
        selRegion: this.formItem.selRegion,
        brands: this.brandlist,
        brandtype: this.formItem.searchtype,
        source: this.formItem.resultcol
      }
      // console.log(this.formItem.selRegion)
      return JSON.stringify(f)
    },
    getVipInfo () {
      // 获取用户信息
      var that = this
      var url = this.$store.state.baseurl + '/mapi/user/getvip'
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          // console.log('登录成功', res.data)
          var vinfo = res.data.data
          // console.log('vinfo', vinfo)
          that.$store.commit('SETVIP', vinfo)
        } else {
          console.log('getvip error', res)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
      })
    },
    checkkw () {
      let t = this.formItem.keywords.replace(/\r\n/g, ',')
      let r = t.replace(/\n/g, ',')
      var ka = r.split(',')
      if (ka.length > this.kwnum) {
        if (this.kwtip.length > 0) {
          this.$Message.error({
            content: this.kwtip + '，当前为' + ka.length + '个',
            duration: 5
          })
        }
      }
    },
    checkregion () {
      var l = this.formItem.selRegion.length
      if (this.formItem.all) {
        l += 1
      }
      if (l > this.regionnum) {
        if (this.regiontip.length > 0) {
          this.$Message.error({
            content: this.regiontip + '，当前为' + l + '个',
            duration: 5
          })
        }
      }
    },
    gentip (val) {
      if (!val) {
        return
      }
      this.vipname = helper.getName(val)
      this.kwnum = helper.getKwNum(val)
      this.regionnum = helper.getRegionNum(val)
      var name = this.vipname
      if (name === '个人中心') {
        name = ''
      } else {
        name += '用户'
      }
      name = ''
      this.kwtip = name + '可以同时采集' + this.kwnum + '个关键字'
      if (this.regionnum < 500) {
        this.regiontip = name + '可以同时选择' + this.regionnum + '个地区'
      } else {
        this.regiontip = name + '不限制选择地区数量'
      }
      // 同时更新一下vipinfo到表达，供插件使用
      this.vipinfo = JSON.stringify(this.$store.state.vipinfo)
    },
    timehandle () {
      var t = new Date().getTime()
      if (this.taskts <= 10000) {
        return
      }
      var tt = t - this.taskts
      if (tt >= 180000 && (this.process < 100) && (this.tasklist.length > 0 || this.mallcount > 0)) {
        if (this.iniscontinueV.length === 0) {
          this.iniscontinueV = '1'
        }
      }
    },
    contok () {
      this.test()
      this.iniscontinueV = ''
      this.message = ''
      console.log('点击继续了')
    },
    test () {
      // console.log('test--')
      this.message = ''
    },
    handleShengCheckAll (status) {
      if (status) {
        for (var t in this.regions) {
          if (this.formItem.selRegion.indexOf(t) === -1) {
            this.formItem.selRegion.push(t)
          }
        }
      } else {
        for (let t in this.regions) {
          if (this.formItem.selRegion.indexOf(t) !== -1) {
            this.formItem.selRegion.splice(this.formItem.selRegion.indexOf(t), 1)
          }
        }
      }
    },
    handleShiCheckAll (param) {
      if (param in this.subCheck) {
        this.subCheck[param] = !this.subCheck[param]
      } else {
        this.subCheck[param] = true
      }
      if (this.subCheck[param]) {
        for (var t in this.pro_city[param]) {
          if (this.formItem.selRegion.indexOf(t) === -1) {
            this.formItem.selRegion.push(t)
          }
        }
      } else {
        for (let t in this.pro_city[param]) {
          if (this.formItem.selRegion.indexOf(t) !== -1) {
            this.formItem.selRegion.splice(this.formItem.selRegion.indexOf(t), 1)
          }
        }
      }
    },
    cleardata () {
      this.downlist.length = 0
      this.downlistjson = ''
      this.tasklist.length = 0
      this.taskts = 0
      this.mallfinished = 0
      this.mallcount = 0
    },
    format (val) {
      return 'Progress: ' + this.process + '%'
    },
    loaddetail (id) {
      var url = '/mapi/itask/detail'
      console.log('url', url)
      var that = this
      const msg = this.$Message.loading({
        content: 'Loading...',
        duration: 0
      })

      this.axios.get(
        url,
        {
          params: {
            id: id
          }
        }
      ).then(function (res) {
        setTimeout(msg, 0)
        if (res.data.code === 200) {
          var param = res.data.data
          param.begin_at = new Date(parseInt(param.begin_at) * 1000)
          param.end_at = new Date(parseInt(param.end_at) * 1000)
          if (param.online) {
            param.online = true
          } else {
            param.online = false
          }
          param.type = param.type.toString()
          if (param.region_code.length > 0) {
            that.selRegion = param.region_code.split(',')
          }
          that.formItem = param
        } else {
          console.log('loaddetail error', res)
          // that.$Message.info(res.data.msg)
          that.message = res.data.msg
        }
      }).catch((e) => {
        setTimeout(msg, 0)
        console.log('获取数据失败', e)
        // that.$Message.info('获取数据失败')
        that.message = '获取数据失败'
      })
    },
    commit () {
      // 获取用户信息
      var url = '/mapi/itask/edit'
      console.log('url', url)
      var that = this
      var param = {}
      param.begin_at = this.formItem.begin_at.getTime() / 1000
      param.end_at = this.formItem.end_at.getTime() / 1000
      if (this.formItem.online === true) {
        param.online = 1
      } else {
        param.online = 0
      }
      param.id = this.formItem.id
      param.keyword = this.formItem.keyword
      param.type = this.formItem.type
      param.region_code = this.selRegion
      const msg = this.$Message.loading({
        content: 'Loading...',
        duration: 0
      })

      this.axios.post(
        url,
        param
      ).then(function (res) {
        setTimeout(msg, 0)
        if (res.data.code === 200) {
          if (res.data.data.id && res.data.data.id > 0) {
            that.formItem.id = res.data.data.id
            that.$Message.info('保存成功')
            that.$router.push({
              path: '/'
            })
          }
        } else {
          console.log('conform error', res)
          // that.$Message.info(res.data.msg)
          that.message = res.data.msg
        }
      }).catch((e) => {
        setTimeout(msg, 0)
        console.log('保存数据失败', e)
        // that.$Message.info('保存获取数据失败')
        that.message = '保存获取数据失败'
      })
    },
    cancel () {
      console.log('cancel')
      this.$router.push({
        path: '/'
      })
    },
    commit_test () {
      // Make a simple request:
      // console.log('Sending ping from the page')
      var that = this
      var url = this.$store.state.baseurl + '/mapi/user/userinfo'
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          console.log('登录成功', res.data)
          var uinfo = res.data.data
          console.log('userinfo', uinfo)
          helper.putUser(uinfo)
          that.$router.push({
            path: '/'
          })
        } else if (res.data.code === 401) {
          helper.removeLogin()
          helper.removeUser()
        } else if (res.data.code === 403) {
        } else {
          console.log('conform error', res)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.field-header {
  margin-bottom: 10px;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  margin: 10px 0 20px;
  border-width: 1px 0 0;
  border-color: #e6e6e6;
  touch-action: pan-y;
  text-align: left;
  .f-title {
    margin-left: 20px;
    padding: 0 10px;
    font-size: 20px;
    font-weight: 300;
  }
}
.sec {
  // font-size: 16px;
  font-weight: 400;
  color: cornflowerblue;
}
.wxts-p {
  text-align: left;
  margin: 0 0 0 78px;
}
@media (max-width: 768px){
  .wxts-p {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/brand.vue